import { Link } from 'react-router';
import BlogHeader from './BlogHeader.jsx';
import flowerplants from './images/flowerplants.png';
import esteta from './images/esteta_logo.png';
import blueBreeze from './images/bluebreeze.png';
import avmLogo from './images/avm-logo.png';
import vitLogo from './images/vit-logo.png';
import petkovaLogo from './images/petkova-logo.png';
import sacp from './images/sacp_logo.png';
import handshake from './images/handshake copy.png';
import untitledNobg from './images/Untitled-nobg.png';

function Blog() {
  return (
    <>
        <BlogHeader />
        <section className="blog blog-section" id="about-us">
            <div className="container">
                <div className="title text-center">
                    <h1 className="title-blue blog-title">
                        Блог        
                    </h1>
                </div>
                <div className="container">

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://avm.vekotasoft.com" target="_blank">
                                    <img className="mr-4" src={avmLogo} alt="Организационна система на счетоводна къща АВМ Консултинг Груп" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">Организационна система на счетоводна къща АВМ Консултинг Груп</h5>
                                    <span className="blog-content-1">
                                        <p>28.04.2026</p>
                                        <p>АВМ Консултинг Груп ООД е счетоводна къща, която предоставя счетоводни услуги, данъчни и бизнес консултации и виртуален офис на малки, средни и големи предприятия.</p>
                                        <p>Създадохме интегриран софтуер, който автоматизира основни бизнес процеси използвани от компанията. По този начин дейности вършени преди за часове или дни вече се осъщестяват за минути. </p>
                                        <Link to="/blog/avm-consult" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://vit.bg" target="_blank">
                                    <img className="mr-4" src={vitLogo} alt="ВИТ - борсата за матраци" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">ВИТ - борсата за матраци</h5>
                                    <span className="blog-content-1">
                                        <p>25.03.2026</p>
                                        <p>В е-магазина на ВИТ – Борсата за матраци предлагаме разнообразие от над 800 матраци. </p>
                                        <p>Компанията е създадена през 1996 г. и за първи път в България представя водещите марки матраци на едно място. Днес ВИТ – Борсата за матраци има 10 работещи франчайз обекта в страната. </p>
                                        <Link to="/blog/vit" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://petkova.bg" target="_blank">
                                    <img className="mr-4" src={petkovaLogo} alt="Правен съветник по недвижими имоти Мартина Петкова" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">Правен съветник по недвижими имоти Мартина Петкова</h5>
                                    <span className="blog-content-1">
                                        <p>20.02.2026</p>
                                        <p>Поддържаме сайта на Мартина Петкова, която е юрист и икономист.  </p>
                                        <p>Нейната дейност е специализирана в правните съвети по недвижими имоти и надеждната юридическа превенция при покупката им. </p>
                                        <Link to="/blog/martina-petkova" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://bluebreeze-travel.com" target="_blank">
                                    <img className="mr-4" src={blueBreeze} alt="Сайт на туристическа агенция" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">Сайт на туристическа агенция Блу Брийз Травъл</h5>
                                    <span className="blog-content-1">
                                        <p>29.01.2026</p>
                                        <p>Блу Брийз Травел е туристическа компания родена от спонтанната идея за пътешествия в компания на други пътешественици по душа. </p>
                                        <p>Собственичката Боряна като малка доста време е живяла в Близкия Изток, след което със започване на работа в различни компании е продължила да пътешества, много пъти съвсем сама. </p>
                                        <Link to="/blog/bluebreeze-travel" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://sacp.government.bg" target="_blank">
                                    <img className="mr-4" src={sacp} alt="Нов сайт на Държавната агенция за закрила на детето" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">Нов сайт на Държавната агенция за закрила на детето</h5>
                                    <span className="blog-content-1">
                                        <p>07.01.2026</p>
                                        <p>Пуснахме в експлоатация новия сайт на Държавната агенция за закрила на детето (ДАЗД). </p>
                                        <p> Порталът е модернизиран, оптимизиран и представящ дейността  на агенцията по достъпен и удобен за гражданите начин. </p>
                                        <Link to="/blog/sacp" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://maxgroupevents.org" target="_blank">
                                    <img className="mr-4" src={handshake} alt="ERP system" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">ERP системата на Max Group Events</h5>
                                    <span className="blog-content-1">
                                        <p>15.12.2025</p>
                                        <p>(ERP - Enterprise Resource Planning, Планиране на ресурсите на предприятието) е интегриран софтуер, който обединява и автоматизира основните бизнес процеси (финанси, производство, човешки ресурси, продажби, логистика) на една компания в единна система с обща база данни. </p>
                                        <p> По този начин се осигурява видимост в реално време и ефективно управление на ресурсите. </p>
                                        <Link to="/blog/erp-sistemata-na-max-group-events" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://toilet-cubicles.bg" target="_blank">
                                    <img className="mr-4" src={esteta} alt="Сайт за преградни стени и wc кабини" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">Сайт за преградни стени и wc кабини на Естета Дизайн</h5>
                                    <span className="blog-content-1">
                                        <p>20.11.2025</p>
                                        <p>Естета Дизайн е млада и иновативна компания, специализирана в проектирането и изработката на WC кабини, писоарни прегради, душ кабини и различни типове преградни системи от HPL плоскости.</p>
                                        <Link to="/blog/esteta-design-pregradni-steni-wc-kabini" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to="https://flowerplants.eu" target="_blank">
                                    <img className="mr-4" src={flowerplants} alt="E-магазин за цветя и растения" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">E-магазин за цветя и растения</h5>
                                    <span className="blog-content-1">
                                        <p>26.09.2025</p>
                                        <p>Новият електронен магазин, който завършихме е специализиран в продажбата на всякакви цветя, растения, разсади, плодни храсти, луковици и други подходящи за всеки дом и градина.</p>
                                        <p>Разширяваме успешното ни партньорство с Оакплантс 78 ЕООД. След групата онлайн магазини базирани на OpenCart пуснахме в екслоатация и нов базиран на WordPress и WooCommerce. </p>
                                        <Link to="/blog/e-shop-flower-plants" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init">
                                <Link to="https://maxgroupevents.org" target="_blank">
                                    <img className="mr-4" src={handshake} alt="CRM system" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">СРМ системата на Max Group Events</h5>
                                    <span className="blog-content-1">
                                        <p>08.09.2025</p>
                                        <p>Системата за управление на взаимоотношенията с клиентите (CRM) е приложен софтуер за всякакви бизнес организации и фирми, който управлява взаимодействието с настоящи и бъдещи клиенти.</p>
                                        <p>В днешното време на силна конкуренция бизнесът все повече разчита на CRM системите за спечелване на нови клиенти и за улесняване на комуникацията и взаимоотношенията с тях. </p>
                                        <Link to="/blog/crm-sistemata-na-max-group-events" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init">
                                <Link to="https://www.razsadi.net" target="_blank">
                                    <img className="mr-4" src={untitledNobg} alt="E-shop" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-1">Онлайн магазини за разсади, растения и овощни дървета</h5>
                                    <span className="blog-content-1">
                                        <p>05.08.2025</p>
                                        <p>Изградихме успешно партньорство с Оакплантс 78 ЕООД.</p>
                                        <p>Изграждането и поддържането на групата е-магазини на фирмата е наш постоянен ангажимент, който изпълняваме с удоволствие.</p>
                                        <Link to="/blog/onlain-magazini-za-razsadi-rasteniq-i-ovoshtni-durveta" className="blogLink">
                                            Виж още...
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default Blog;
